// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"register-page_wrapper__7_qQa","image":"register-page_image__pqUpA"};